export default __webpack_public_path__ + "static/media/report_navicon-light.b27e6d8b.svg";